import { v4 as uuid } from 'uuid';
import { useCookie } from 'react-use';
import * as React from 'react';
import { LogLevel } from '@optimizely/optimizely-sdk';
import { createInstance, enums } from '@optimizely/react-sdk';
import { useAnalytics } from '../analytics/hooks';

export const optimizelyClient = createInstance({
  sdkKey: process.env.NEXT_PUBLIC_OPTIMIZELY_SDK_KEY,
  logLevel: LogLevel.ERROR,
});

interface Notification {
  type: string;
  userId: string;
  decisionInfo: {
    flagKey: string;
    enabled: boolean;
    decisionEventDispatched: boolean;
  };
}
export function useOptimizely() {
  const [optimizelyUserId, setOptimizelyUserId] = useCookie('optimizelyEndUserId');

  const { sendEvent } = useAnalytics();
  if (!optimizelyUserId) {
    setOptimizelyUserId(uuid());
  }

  const onDecision = React.useCallback(
    ({ type, decisionInfo }: Notification) => {
      if (type === 'flag') {
        sendEvent({
          event: 'CRO',
          description: decisionInfo.flagKey,
          element: 'NL',
          type,
          result: decisionInfo.enabled ? 'Variant' : 'Default',
          interaction: false,
        });
      }
    },
    [sendEvent]
  );

  React.useEffect(() => {
    optimizelyClient.notificationCenter.addNotificationListener<Notification>(
      enums.NOTIFICATION_TYPES.DECISION,
      onDecision
    );
  });

  return { userId: optimizelyUserId };
}

export const OptimizelyFlagContext = React.createContext<Record<string, boolean>>({});

export const OptimizelyFlagProvider = OptimizelyFlagContext.Provider;

export const useOptimizelyFlagContext = () => React.useContext(OptimizelyFlagContext);
